<div class="p-fluid p-formgrid p-grid">
  <div class="p-col-12 p-md-3">
    <p-card header="Filtros" (keyup.enter)="pesquisar()">
      <div class="p-grid">
        <m-restricao-number label="Id" [restricao]="restricoes.atributo('id')"></m-restricao-number>
        <m-restricao-string label="Fonte de dados" [restricao]="restricoes.atributo('fonteDados.nome')"></m-restricao-string>
        <m-restricao-string label="Origem Id" [restricao]="restricoes.atributo('origemId')"></m-restricao-string>
        <m-restricao-string label="Nome" [restricao]="restricoes.atributo('nome')"></m-restricao-string>
      </div>
      <p-footer>
        <div class="p-grid p-fluid">
          <div class="p-field p-col">
            <button pButton label="Pesquisar" (click)="pesquisar()"></button>
          </div>
          <div class="p-field p-col">
            <button pButton class="p-button-secondary" label="Limpar" (click)="limpar()"></button>
          </div>
        </div>
      </p-footer>
    </p-card>
  </div>

  <div class="p-col-12 p-md-9">
    <p-card>
      <div class="p-card-title">
        Lista de pessoas
        <span *ngIf="carregandoPessoas">
          <em class="pi-fw pi pi-spin pi-spinner"></em>
        </span>
        <span *ngIf="error" style="color: red">
          <em class="pi pi-times" pTooltip="Erro ao carregar os dados da pesquisa!"></em>
        </span>
      </div>

      <div *ngIf="pessoas === undefined || pessoas?.length === 0"  style="display: flex; justify-content: center; align-items: center; height: 700px;">
        <p *ngIf="pessoas === undefined">
          Por favor realize uma pesquisa
        </p>

        <p *ngIf="pessoas?.length === 0">
          Nenhum resultado foi encontrado
        </p>
      </div>

      <div *ngIf="pessoas !== undefined" [hidden]="pessoas?.length === 0">
        <p-virtualScroller
          #vsPessoas class="lista-pessoas"
          [value]="pessoas"
          scrollHeight="700px"
          [itemSize]="100"
          [rows]="quantidadeRegistros"
          [lazy]="true"
          (onLazyLoad)="onLazyLoad($event.first)">
          <ng-template let-pessoa pTemplate="item">
            <a class="lista-pessoas__item border p-border-top" pTooltip="Visualizar a pessoa" [routerLink]="['/pessoa/visualizar/', pessoa.id]">
              <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12">
                  <ul class="list-group">
                    <li class="list-title-color">
                      <span class="lista-pessoas__nome highlight">{{ pessoa.id }} - {{ pessoa.nome }}</span>
                    </li>
                    <li class="fonte-dados">
                      {{pessoa.fonteDados.nome}} - {{pessoa.origemId}}
                    </li>
                    <li class="list-group-item disabled onbadge">
                      <span [ngClass]="pessoa.tipo === 'FISICA' ? 'badge badge-blue' : 'badge badge-success'">{{ pessoa.tipo === 'FISICA' ? 'Física' : 'Jurídica' }}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </a>
          </ng-template>
          <ng-template let-car pTemplate="loadingItem">
            <div class="lista-pessoas__carregando border p-border-top">
              <em class="pi-fw pi pi-spin pi-spinner"></em>
            </div>
          </ng-template>
        </p-virtualScroller>
      </div>
    </p-card>
  </div>
</div>
